import { CardBenefits } from '@/types/credit';
import { RequestErrorResponse } from '@/utils/request';

export const mapBanks = (banks: string[] | RequestErrorResponse) => {
  if ('error' in banks) {
    return [
      {
        value: 'error',
        label: 'erro ao carregar bancos',
        category: 'bank',
      },
    ];
  }

  return banks.map((b) => {
    return {
      value: b,
      label: b,
      category: 'bank',
    };
  });
};

export const mapBenefits = (benefits: CardBenefits | RequestErrorResponse) => {
  if ('error' in benefits) {
    return [
      {
        value: 'error',
        label: 'erro ao carregar benefícios',
        category: 'benefit',
      },
    ];
  }

  return benefits.map((b) => {
    return {
      value: b,
      label: b,
      category: 'benefit',
    };
  });
};
